import Container from "Components/Container/Container";
import React, { useLayoutEffect, useRef, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Link } from "react-router-dom";
import { CaretUp } from "@phosphor-icons/react";

const HeroMobile = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const slideRefs = useRef([]);
  const [maxHeight, setMaxHeight] = useState(0);

  useLayoutEffect(() => {
    // Ensure slideRefs.current is populated
    if (
      slideRefs.current.length === 0 ||
      slideRefs.current.every((ref) => ref === null)
    ) {
      return;
    }

    // Calculate the maximum height after the DOM is fully rendered
    const heights = slideRefs.current.map((slide) => {
      if (slide) {
        return slide.offsetHeight;
      }
      return 0;
    });

    const maxHeight = Math.max(...heights);

    setMaxHeight(maxHeight);
  }, [data]);

  return (
    <section className="xl:hidden py-20 pt-[18vh] bg-primary text-white">
      <Container>
        <Swiper
          spaceBetween={6}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          modules={[Autoplay, Navigation]}
          className=""
          speed={1000}
        >
          {data?.map(({ title, text, sub_title }, index) => (
            <SwiperSlide
              ref={(el) => {
                slideRefs.current[index] = el;
              }}
              style={{
                height: maxHeight ? `${maxHeight}px` : "auto",
              }}
              key={index}
            >
              <div>
                <h4 className="text-4xl text-secondary titles-font">{title}</h4>
                <h6 className="text-lg font-medium">{sub_title}</h6>
                <p className="mt-2">{text}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default HeroMobile;
